import { render, staticRenderFns } from "./documentForm.vue?vue&type=template&id=f6ace7a4&scoped=true&"
import script from "./documentForm.vue?vue&type=script&lang=js&"
export * from "./documentForm.vue?vue&type=script&lang=js&"
import style0 from "./documentForm.vue?vue&type=style&index=0&id=f6ace7a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ace7a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6ace7a4')) {
      api.createRecord('f6ace7a4', component.options)
    } else {
      api.reload('f6ace7a4', component.options)
    }
    module.hot.accept("./documentForm.vue?vue&type=template&id=f6ace7a4&scoped=true&", function () {
      api.rerender('f6ace7a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/documentForm.vue"
export default component.exports